import React from "react";
import {Container} from "reactstrap";
import ReactGA from "react-ga4";
import { IYoutubeVideo } from "../../Interfaces/shared";


const YouTubeVideoSection = ({ url, eventAction, eventLabel }: IYoutubeVideo) => {

  const handleVideoEvent = () => {
    ReactGA.event({
      category: 'Button',
      action: eventAction,
      label: eventLabel,
    });
  }

  return(<div onClick={handleVideoEvent} className="youTube-video-section bg-white py-5">
     <Container className="container-fluid">
      <iframe className="player" 
              src={url}
              width="100%" 
              height="450" 
              title="YouTube video player" 
              frameBorder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen 
      />
     </Container>
  </div>
  )
}

export default YouTubeVideoSection;